/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import * as React from 'react'

import { useCarousel } from '@/components/e-commerce/kits/kit-gallery-carousel/Carousel'
import { cn } from '@/utils/css'

const CarouselThumbnails = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    const { carouselThumbsRef } = useCarousel()

    return (
      <div className={'overflow-hidden h-full'} ref={carouselThumbsRef}>
        <div ref={ref} className={cn('flex flex-row gap-2 h-full', className)} {...props} />
      </div>
    )
  },
)
CarouselThumbnails.displayName = 'CarouselThumbnails'

export { CarouselThumbnails }
